import * as $ from 'jquery';
import SlimSelect from 'slim-select';

/**
 * DownloadController
 *
 * @author Sinian Zhang <s.zhang@andersundsehr.com>
 */
export default class DownloadController {
  private downLoadFilterElements = document.querySelectorAll('.js-slim-select-download');
  private downloadFilterObjects: SlimSelect[] = [];

  init() {
    this.downLoadFilterElements?.forEach((selectElement) => {
      this.downloadFilterObjects.push(new SlimSelect({
          select: selectElement,
          showSearch: false,
        }),
      );
    });
  }

  reInit() {
    this.downloadFilterObjects.forEach((select) => {
      // force slimSelect to re-render
      select.disable();
      select.enable();
    });
  }

  /**
   * @param {string} responseData
   * @param {jQuery} $ajaxTarget
   * @returns {string}
   */
  beforeShowResults(responseData, $ajaxTarget) {
    const filterNameSelectIdMap = {
      resourceProductFamilies: 'resourceProductFamily',
      resourceTypes: 'resourceType',
      languages: 'language',
      resourceCompanies: 'resourceCompany',
    };
    const value = $(responseData).find('#js-intelligent-filter-data').val();
    let intelligentFilters = {};
    if (value) {
      intelligentFilters = JSON.parse(value.toString());
    }
    $.each(intelligentFilters, (filterName, optionValues) => {
      const select = $ajaxTarget.find('div.downloads__filter select#' + filterNameSelectIdMap[filterName]);
      select.find('option').prop('disabled', true);
      select.find('option[value=0]').prop('disabled', false);
      select.find('option[value=-1]').prop('disabled', false);
      $.each(optionValues, (index, optionValue) => {
        select.find('option[value=' + optionValue + ']').prop('disabled', false);
      });
    });
    $(responseData).find('#js-intelligent-filter-data').val('');
    this.reInit();
    return responseData;
  }
}
